//挂号相关接口
import Http from '../Core/Http';
export default class Register extends Http {
  constructor(config) {
    super(config);
  }
  //获取一级科室分类_GetDepartmentClass）
  GetDepartmentClass(data) {
    return this._post('api/Interaction/GetDepartmentClass', null, data)
  }

  //通过一级科室id获取科子科室
  GetDepartmentOnDutyV2(data) {
    return this._post('api/Interaction/GetDepartmentOnDutyV2', null, data)
  }

  //获取医生排班信息GetDoctorSchedule
  GetDoctorScheduleV2(data) {
    return this._post('api/Interaction/GetDoctorScheduleV2', null, data)
  }

  //获取医生挂号详情GetDoctorOnDutyDetail
  GetDoctorOnDutyDetail(data) {
    return this._post('api/Interaction/GetDoctorOnDutyDetail', null, data)
  }

  //获取挂号列表POST/api/Interaction/GetRegistrationList
  GetRegistrationList(data) {
    return this._post('api/Interaction/GetRegistrationList', null, data)
  }

  //获取医生排班POST/api/Interaction/SearchDoctor
  SearchDoctor(data) {
    return this._post('api/Interaction/SearchDoctor', null, data)
  }

  //挂号POST / api / Interaction / RegisterV2
  RegisterV2(data) {
    return this._post('api/Interaction/RegisterV2', null, data)
  }
  // 挂号到科室
  RegisterV3(data) {
    return this._post('api/Interaction/RegisterV3', null, data)
  }
  // 0元挂号
  RegisterV4(data) {
    return this._post('api/Interaction/RegisterV4', null, data)
  }
  //科室挂号
  GetDepartmentOnDutyV3(data){
    return this._post("api/Interaction/GetDepartmentOnDutyV3",null,data)
  }
}



// WEBPACK FOOTER //
// ./src/lib/PMA/Register.js